import { Message, MessageBox, Loading } from 'element-ui'
import axios from 'axios';
import conf from './config';
import router from './routes';
import store from './store';
import sha256 from 'js-sha256';
import qs from 'qs';
import encrypt from './communal/encrypt';
import Cookies from 'js-cookie';


axios.defaults.withCredentials = true;
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';  //此处是增加的代码，设置请求头的类型
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';  //此处是增加的代码，设置请求头的类型
// axios.defaults.headers.common['deviceChannel'] = 'gclife_bmp_pc';

var processing_time = '';
var request_time = '';
var api_url = '';

export default {

    //调用接口
    request: function(url, para, method, suss, err, header="form") {
        // let loadingInstance = Loading.service({
        //     fullscreen: true,
        //     lock: true,
        //     // spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0)'
        // });
        para = JSON.parse(JSON.stringify(para));

        var api_para_sk = sha256(JSON.stringify(para));

        //是否清除缓存
        if (para === 'clear') {
            this.clear_cache_api(url, api_para_sk);
            conf.dbug ? console.log('成功清理' + url + '的缓存。') : '';
            return;
        }

        //开始计时
        conf.dbug ? console.time('参数处理时长') : '';
        conf.dbug ? console.group(url) : '';

        //参数是否为空
        para == '' || para == undefined ? para = [] : [];

        para['paramsJson'] = JSON.stringify(para);

        //取得接口地址
        const apiurl = conf.api_url() + url;

        //加上随机数
        para['_t'] = sha256(this.randomWord(true, 10, 20) + (new Date()).getTime() + this.randomWord(true, 5, 10));

        //是否开启dbug
        conf.dbug ? console.log('接口地址：' + apiurl + ';') : '';

        //缓存是否存在 是否需要缓存
        if (this.cache_api(url, api_para_sk) != false && conf.is_cache_api.indexOf(url) !== -1) {

            //回调是否存在
            var _suss = suss();
            //异常捕获
            try {
                _suss(this.cache_api(url, api_para_sk));
            } catch (err) {
                console.warn(url + '接口成功回调内有错误!');
                console.error(err);
            }

            //是否开启dbug
            conf.dbug ? console.timeEnd('参数处理时长') : '';
            conf.dbug ? console.log('返回结果：') : '';
            conf.dbug ? console.log(this.cache_api(url, api_para_sk)) : '';
            conf.dbug ? console.log('ps:来自缓存') : '';
            conf.dbug ? console.groupEnd() : '';

            return;

        }

        //参数处理
        for (var i in para) {

            //字符串去除前后空格
            if (para[i] !== '' && para[i] !== null && para[i] !== undefined && typeof para[i] === 'string') {
                para[i] = para[i].replace(/(^\s*)|(\s*$)/g, "");
                // para[i]=para[i].replace(/\s/g, '&nbsp;');
            }

            //参数本身为空格
            if (para[i] === ' ') {
                para[i] = '';
            }

            //是否开启dbug
            conf.dbug ? console.log('参数：《' + i + '》=' + para[i] + '；') : '';
            
            // 加密
            if (para[i] !== '' && para[i] !== null && para[i] !== undefined) {
                para[i] = encrypt.EncryptData(para[i]);
            }

        }

        //是否需要拼接token
        if (conf.untoken.indexOf(url) === -1) {
            para['token'] = store.getters.token || Cookies.get('u8d_oasite_token');
        }

        //加上解密标识
        para['is_decode'] = sha256(this.randomWord(true, 10, 20) + (new Date()).getTime() + this.randomWord(true, 5, 10));

        //是否开启dbug
        conf.dbug ? console.timeEnd('参数处理时长') : '';
        // alert('标识'+JSON.stringify(para['is_decode']))
        //发起请求
        axios(apiurl, {

            params: method != 'post' ? para : '',
            data: header == 'form'? method == 'post' ? qs.stringify(para) : '' : para,
            method: method,
            timeout: conf.timeout,
            headers: { 
                'Content-Type': header == 'form'?'application/x-www-form-urlencoded;charset=UTF-8':'application/json;charset=UTF-8',
                'Authorization': 'Bearer '+store.getters.token,
                'token': store.getters.token,
            },

            //调用是否成功(请求是否成功)
        }).then(e => {
            // loadingInstance.close();
            
            //是否需要解密
            if (e.data.code === undefined && e.data.msg === undefined && e.data.result === undefined) {
                e.data = encrypt.DecryptData(e.data);
            }

            //是否需要转json对象
            if (e.data.isConversion !== undefined && typeof e.data.result == 'string') {
                e.data.result =  JSON.parse(e.data.result);
            }

            //是否开启dbug
            conf.dbug ? console.log('返回结果：') : '';
            conf.dbug ? console.log(e.data) : '';
            conf.dbug ? console.groupEnd() : '';
            //是否登录失效
            if (e.data.code == conf.invalid_login) {

                //提示
                Message.error('登录状态已过期,请重新登录');

                //回调是否存在
                var _err = err();
                if (_err != null) {

                    //异常捕获
                    try {
                        _err(e.data);
                    } catch (err) {
                        console.warn(url + '接口失败回调内有错误!');
                        console.error(err);
                    }

                } else {
                  //Message.error(e.data.msg);
                }

                //跳转到登录页
                if (store.getters.token.corpId) {
                    router.push('/login?corpId='+store.getters.token.corpId);
                } else {
                    router.push('/login');
                }
                return;

            }

            //是否已离职
            if (e.data.code == conf.quit_reg) {

                //提示
                Message.error('该账号已离职，请重新登录');
                //回调是否存在
                var _err = err();
                if (_err != null) {

                    //异常捕获
                    try {
                        _err(e.data);
                    } catch (err) {
                        console.warn(url + '接口失败回调内有错误!');
                        console.error(err);
                    }

                } else {
                    // Message.error(e.data.msg);
                }

                //跳转到登录页
                alert("该账号已离职，请重新登录")
                router.push('/login');
                return;
            }

            //调用是否成功(业务校验)
            if (e.data.code != conf.api_suss_code) {

                //关闭加载动画

                //回调是否存在
                var _err = err();
                if (_err != null) {

                    //异常捕获
                    try {
                        _err(e.data);
                    } catch (err) {
                        console.warn(url + '接口失败回调内有错误!');
                        console.error(err);
                    }

                } else {
                    Message.error(e.data.msg);
                }

            } else {

                //是否需要缓存
                if (conf.is_cache_api.indexOf(url) !== -1) {
                    var key = url + ':' + store.getters.token + ':' + api_para_sk;
                    store.state.api[key] = e.data;
                }

                //回调是否存在
                var _suss = suss();
                if (_suss != null) {

                    //异常捕获
                    try {
                        _suss(e.data);
                    } catch (err) {
                        console.warn(url + '接口成功回调内有错误!');
                        console.error(err);
                    }

                } else {
                    //关闭加载动画
                    console.warn('注意：没有传入成功回调  接口地址' + url);
                }

            }

            //调用失败(请求失败)
        }).catch((error, timeout) => {
            // loadingInstance.close();
            //是否开启dbug
            conf.dbug ? console.error('调用失败') : '';
            conf.dbug ? console.groupEnd() : '';

            //说明借口
            Message.error('网络异常，请重试');

            //错误回调是否存在
            var _err = err();
            if (_err != null) {
                //异常捕获
                try {
                    _err();
                } catch (err) {
                    console.warn(url + 'axios调用失败回调内有错误!');
                    console.error(err);
                }
            }

            //控制台偷偷打印原因
            // console.log(error);

        })

    },

    //上传文件
    upload: function(url, para, suss, err, complete_fun) {

        //参数处理
        var form = new FormData(); // FormData 对象

        para['paramsJson'] = JSON.stringify(para);

        //转为form_data
        for (var i in para) {
            //是否多文件
            if (i == 'attachmentLists') {
                for (var j in para[i]) {
                    form.append(i, para[i][j], para[i][j].name);
                }
            } else {
                form.append(i, para[i]);
            }
        }
        
        //没有文件时
        if(para.attachmentLists == undefined){
            form.append('attachmentLists', new Blob() , '_&ReplaceEmpty.jpg');
        }
        

        para = form;

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data', //之前说的以表单传数据的格式来传递fromdata
                'Authorization': 'Bearer '+store.getters.token
            },
            onUploadProgress: progressEvent => {


            }
        };

        //进度条
        var p = 0;
        var _complete_fun = complete_fun();
        var t = setInterval(()=>{
            if (_complete_fun != null) {
                _complete_fun(p);
            }
            if(p<94){
                p = p+Math.floor(Math.random()*5);
            }
        },500);

        //请求
        axios.post(conf.api_url() + url, para, config).then((e) => {

            //是否登录失效
            if (e.data.code == conf.invalid_login) {

                //提示
                Message.error('登录状态已过期,请重新登录');

                //进度条完成
                clearTimeout(t);
                if (_complete_fun != null) {
                    _complete_fun(100);
                }

                //跳转到登录页
                alert("登录状态已过期")
                router.push('/login');
                return;

            }
            //调用是否成功(业务校验)
            if (e.data.code != conf.api_suss_code) {

                //回调是否存在
                var _err = err();
                if (_err != null) {
                    //进度条完成
                    clearTimeout(t);
                    if (_complete_fun != null) {
                        _complete_fun(100);
                    }
                    //异常捕获
                    try {
                        _err(e.data);
                    } catch (err) {
                        console.warn(url + '接口成功回调内有错误!');
                        console.error(err);
                    }
                } else {
                    //进度条完成
                    clearTimeout(t);
                    if (_complete_fun != null) {
                        _complete_fun(100);
                    }
                    Message.error(e.data.msg);
                }

                

            } else {

                //回调是否存在
                var _suss = suss();
                if (_suss != null) {
                    //进度条完成
                    clearTimeout(t);
                    if (_complete_fun != null) {
                        _complete_fun(100);
                    }
                    //异常捕获
                    try {
                        _suss(e.data);
                    } catch (err) {
                        console.warn(url + '接口成功回调内有错误!');
                        console.error(err);
                    }
                } else {
                    //进度条完成
                    clearTimeout(t);
                    if (_complete_fun != null) {
                        _complete_fun(100);
                    }
                    //关闭加载动画
                    console.warn('注意：没有传入成功回调  接口地址' + url);
                }

            }

        }).catch((error) => {

            //进度条完成
            clearTimeout(t);
            if (_complete_fun != null) {
                _complete_fun(100);
            }

            //说明借口
            Message.error('网络异常，请重试');

            //错误回调是否存在
            var _err = err();
            if (_err != null) {
                //异常捕获
                try {
                    _err();
                } catch (err) {
                    console.warn(url + '接口成功回调内有错误!');
                    console.error(err);
                }
            }

        });
    },

    //生成随机数
    randomWord: function(randomFlag, min, max) {

        var str = "",
            pos = "",
            range = min,
            arr = ['/', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        // 随机产生
        if (randomFlag) {
            range = Math.round(Math.random() * (max - min)) + min;
        }
        for (var i = 0; i < range; i++) {
            pos = Math.round(Math.random() * (arr.length - 1));
            str += arr[pos];
        }

        return str;

    },

    //接口缓存
    cache_api: function(url, api_para_sk) {

        var key = url + ':' + store.getters.token + ':' + api_para_sk;
        var ret = false;

        if (store.state.api[key] != null && store.state.api[key] != undefined && store.state.api[key] != '') {
            ret = store.state.api[key];
        }

        return ret;

        // return false;

    },

    //清除当前接口缓存
    clear_cache_api: function(url) {

        var all_cache = store.state.api;
        var key = url + ':' + store.getters.token;
        for (var i in all_cache) {
            if (i.indexOf(key) != -1) {
                store.state.api[i] = null;
            }
        }

    },

    //清除所有接口缓存
    clear_all_cache: function() {
        store.state.api = {};
    },


    //哈希
    sha256: sha256

}


// WEBPACK FOOTER //
// ./src/request.js